import { trackTreatmentV3Event as TE } from "./treatmentV3";
import { startTimedEvent } from "@amplio-common/analytics";
import { fetchTreatmentById, clearTreatmentData, selectTreatment } from "@app/routes/treatmentV3/store/treatmentServerDataSlice";
import { currentUser } from "@app/routes/auth/selectors";
import { selectIsLocked, setIsLocked, setBoardMode } from "@app/routes/treatmentV3/store/studentSlice";
import { ROLES } from "@app/constants";
import { wsUpdateStudentStatus } from "@app/routes/treatmentV3/store/websocketSlice";
import { chatSelectStudentStatusById, chatUpdateStudentStatus, selectNumUnreadMessages, sendChatMessage, setChatWidgetStatusAndUpdateReadTime, setMessageList } from "@app/routes/treatmentV3/store/chatSlice";
import { contentUpdateStudentStatus, selectPinnedBoard, selectStudentStatusById, setPinnedBoard, setIsPresenting, selectIsPresenting, setPreviewBoardMode, setIsShareScreenOn, selectIsShareScreenOn, setPinnedBoardByForce } from "@app/routes/treatmentV3/store/contentSlice";
import { updateStudentStatus, setIsQrCodeDialoOpen, setIsWaitingRoomDialogOpen } from "@app/routes/treatmentV3/store/administrationSlice";
import { PREVIEW_BOARD_ID } from "@app/routes/treatmentV3/constants";
import { VIDEO_SESSION_PAGES } from "@app/common/data/ActivitiessEnums";
import { selectPreviewSelectedActivity, setIsManualShowPlaylist, selectIsManualShowPlaylist, selectStudioActivityPlaylist } from "@app/routes/treatmentV3/store/studioSlice";
import { videoUpdateStudentStatus, videoSelectStudentStatusById, setOpentokErrorMessage, endVideoSession, askToJoinVideo } from "@app/routes/treatmentV3/store/videoSlice";
import { selectIsVideoMuted, selectIsVideoPaused, setIsExitVideo, setIsVideoMuted, setIsVideoPaused, userStartVideo } from "../../routes/treatmentV3/store/videoSlice";
import { CHAT_RECEIVER_POSITION, CHAT_SENDER_POSITION, CHAT_WIDGET_STATUS as CWS } from "@app/routes/treatmentV3/components/chat/ChatUtils";
import { techStatusSelectStudentStatusById, techStatusUpdateStudentStatus } from "@app/routes/treatmentV3/store/techStatusSlice";
import { initErrorList } from "@amplio-common/funcs/techStatusFunc";
import { selectGamePlayList } from "@app/routes/treatmentV3/store/activityLibrarySlice";

export const relevantTreatmentV3EventsBeforeActions = {
  [clearTreatmentData]: (state) => {
    if (selectTreatment(state)) {
      const currUser = currentUser(state);
      const isPresenting = selectIsPresenting(state);
      isPresenting && TE("present_mode_ended", state, null, { endSession: true });
      TE("board_viewed_has_ended", state, null, { endSession: true });
      currUser.role === ROLES.STUDENT.id && selectIsLocked(state) && TE("lock_duration_ended", state, null, { endSession: true });
      currUser.role === ROLES.STUDENT.id && TE("focus_content_change", state, null, { endSession: true });
    }
  },
  [setBoardMode]: (state) => {
    TE("focus_content_change", state, null, {}, () => startTimedEvent("focus_content_change"));
  },
};

export const relevantTreatmentV3EventsAfterActions = {
  [fetchTreatmentById.fulfilled]: (stateBefore, stateAfter) => {
    const currUser = currentUser(stateAfter);
    const h5pGamePlaylist = selectGamePlayList(stateAfter);
    const playlistLength = h5pGamePlaylist?.length;

    TE("treatment_session_loaded", stateAfter, null, { playlist_length: playlistLength });
    startTimedEvent("board_viewed_has_ended");
    currUser.role === ROLES.STUDENT.id && startTimedEvent("focus_content_change");
  },
  [wsUpdateStudentStatus]: (stateBefore, stateAfter, action) => {
    const studentId = action?.payload?.id;
    // WS connect
    action?.payload?.changes?.wsConnected && TE("student_connects_to_ws_class", stateAfter, studentId);
    action?.payload?.changes?.wsConnected === false && TE("student_disconnects_to_ws_class", stateAfter, studentId);
  },
  [contentUpdateStudentStatus]: (stateBefore, stateAfter, action) => {
    const studentId = action?.payload?.id;
    const pinnedBoard = selectPinnedBoard(stateBefore);
    const isAutoRelease = pinnedBoard === PREVIEW_BOARD_ID;
    const { isLocked } = (s => selectStudentStatusById(s, studentId))(stateBefore) || {};
    action?.payload?.changes?.isLocked && TE("initiate_student_lock_class", stateAfter, studentId);
    action?.payload?.changes?.isLocked === false && isLocked && TE("release_student_lock_class", stateAfter, studentId, { auto_release: isAutoRelease });
  },
  [updateStudentStatus]: (stateBefore, stateAfter, action) => {
    const studentId = action?.payload?.id;
    if (action?.payload?.changes?.isArrived !== undefined) {
      const isArrived = action?.payload?.changes?.isArrived;
      const markType = isArrived ? "arrived" : "absent";
      //   let markedBy = "Therapist";
      TE(`student_marked_${markType}_class`, stateAfter, studentId);
    }

    action?.payload?.changes?.isStudentProfileDialogOpen && TE("view_student_profile_class", stateAfter, studentId);
  },
  ////// video
  [setIsWaitingRoomDialogOpen]: (stateBefore, stateAfter, action) => {
    action.payload && TE("open_waiting_room", stateAfter);
  },
  [askToJoinVideo]: (stateBefore, stateAfter) => {
    TE("ask_to_join_press", stateAfter);
  },
  [videoUpdateStudentStatus]: (stateBefore, stateAfter, action) => {
    const studentId = action?.payload?.id;
    const { isVideoPausedByTeacher: wasVideoPausedByTeacher,
      isVideoOn: wasVideoOn,
      isVideoPaused: wasVideoPaused,
      isVideoMuted: wasVideoMuted } = (s => videoSelectStudentStatusById(s, studentId))(stateBefore) || {};
    const { isExitVideo, isKickedFromVideo } = (s => videoSelectStudentStatusById(s, studentId))(stateAfter) || {};
    const exitByTherapist = isExitVideo || isKickedFromVideo;

    const { payload: { changes = {} } = {} } = action || {};
    const { isVideoPending, isVideoOn, isVideoPausedByTeacher, isVideoPaused, isVideoMuted } = changes;

    //video status
    isVideoPending && TE("request_student_camera", stateAfter, studentId);
    isVideoPending === false && Object.keys(changes).length === 1 && TE("student_declined_invite", stateAfter, studentId);

    isVideoOn && TE("student_camera_connection", stateAfter, studentId);
    isVideoOn === false && wasVideoOn && TE("student_camera_disconnection", stateAfter, studentId);

    //TODO: talk to stav to change the spec to this format
    // action?.payload?.changes?.isVideoOn != null && TE("student_camera_connection", stateAfter, studentId, { new_on_status: action?.payload?.changes?.isVideoOn });
    // action?.payload?.changes?.isVideoOn != null && TE(action?.payload?.changes?.isVideoOn ? "student_camera_connection" : "student_camera_disconnection", stateAfter, studentId);

    //mute/pause by teacher
    isVideoPausedByTeacher && TE("pause_student_camera", stateAfter, studentId);
    isVideoPausedByTeacher === false && wasVideoPausedByTeacher && !exitByTherapist && TE("unpause_student_camera", stateAfter, studentId);

    //mute/pause by student
    isVideoPaused && TE("camera_paused_by_student", stateAfter, studentId);
    isVideoPaused === false && wasVideoPaused && !exitByTherapist && TE("camera_unpaused_by_student", stateAfter, studentId);
    isVideoMuted && TE("camera_muted_by_student", stateAfter, studentId);
    isVideoMuted === false && wasVideoMuted && !exitByTherapist && TE("camera_unmuted_by_student", stateAfter, studentId);
  },
  /////
  [setIsQrCodeDialoOpen]: (stateBefore, stateAfter, action) => {
    action.payload && TE("enlarge_code_class", stateAfter);
  },
  [setPinnedBoard.fulfilled]: (stateBefore, stateAfter, action) => {
    const studentId = action.payload === PREVIEW_BOARD_ID ? null : action.payload;
    studentId && TE("view_student_board", stateAfter, studentId, { source: action?.meta?.arg?.src });
    
    action?.meta?.arg?.src !== "re/load page" && TE("board_viewed_has_ended", stateBefore, null, {}, () => startTimedEvent("board_viewed_has_ended"));
  },
  [setIsLocked]: (stateBefore, stateAfter, action) => {
    const isLocked = selectIsLocked(stateBefore);
    action.payload && TE("student_starts_lock_state", stateAfter);
    action.payload && startTimedEvent("lock_duration_ended");
    action.payload === false && isLocked && TE("lock_duration_ended", stateAfter);
  },
  [setIsPresenting]: (stateBefore, stateAfter, action) => {
    const isPresenting = selectIsPresenting(stateBefore);
    action.payload && startTimedEvent("present_mode_ended");
    action.payload === false && isPresenting && TE("present_mode_ended", stateAfter);
  },
  [setPreviewBoardMode]: (stateBefore, stateAfter, action) => {
    const activityPlayList = selectStudioActivityPlaylist(stateBefore);
    action.payload === VIDEO_SESSION_PAGES.ACTIVITY
    && (!selectPreviewSelectedActivity(stateAfter) || selectIsManualShowPlaylist(stateAfter))
    && TE("activity_list_open_activity_menu", stateAfter, null, { playlist_size: activityPlayList.length });
  },
  [setIsManualShowPlaylist]: (stateBefore, stateAfter, action) => action.payload && TE("activity_list_open_activity_menu", stateAfter),
  [userStartVideo.fulfilled]: (stateBefore, stateAfter) => {
    const currUser = currentUser(stateAfter);
    const eventName = currUser.role !== ROLES.STUDENT.id ? "video_status_change" : "enable_student_camera";
    TE(eventName, stateAfter, null, { new_status: true });
  },
  [setOpentokErrorMessage]: (stateBefore, stateAfter, action) => {
    action.payload && TE("opentok_error ", stateAfter, null, { error_msg: action.payload });
  },
  // [setIsOpentokEnabled]: (stateBefore, stateAfter, action) => TE("opentok_status_change", stateAfter, null, { new_status: action.payload }),
  [setIsVideoMuted]: (stateBefore, stateAfter, action) => {
    const wasVideoMuted = selectIsVideoMuted(stateBefore);
    action.payload === false && wasVideoMuted && TE("unmute_video", stateAfter);
    action.payload && !wasVideoMuted && TE("mute_video", stateAfter);
  },
  [setIsVideoPaused]: (stateBefore, stateAfter, action) => {
    const wasVideoPaused = selectIsVideoPaused(stateBefore);
    action.payload === false && wasVideoPaused && TE("unpause_video", stateAfter);
    action.payload && !wasVideoPaused && TE("pause_video", stateAfter);
  },
  [setIsExitVideo]: (stateBefore, stateAfter, action) => {
    const currUser = currentUser(stateAfter);

    //TODO: talk to stav - doesn't make sense that for the student we have two events and for therapist one event with true/false parameter
    action.payload && currUser.role === ROLES.STUDENT.id && TE("disable_student_camera", stateAfter, null);
    action.payload && currUser.role !== ROLES.STUDENT.id && TE("video_status_change", stateAfter, null, { new_status: false });
  },
  [endVideoSession]: (stateBefore, stateAfter) => {
    TE("end_video_session", stateAfter, null);
  },
  [setIsShareScreenOn]: (stateBefore, stateAfter, action) => {
    const wasShareScreenOn = selectIsShareScreenOn(stateBefore);
    wasShareScreenOn !== action.payload && TE("screen_share_status_change", stateAfter, null, { new_status: action.payload });
  },
  [setPinnedBoardByForce]: (stateBefore, stateAfter) => {
    TE("screen_share_status_change", stateAfter, null, { new_status: false });
  },
  //CHAT
  [chatUpdateStudentStatus]: (stateBefore, stateAfter, action) => {
    const studentId = action?.payload?.id;
    const { payload: { changes = {} } = {} } = action || {};
    const { chatWidgetStatus, messageList } = changes;
    const { numUnreadMessages } = (s => chatSelectStudentStatusById(s, studentId))(stateBefore) || {};

    chatWidgetStatus !== undefined && chatWidgetStatus !== CWS.SUSPENDED && TE(`chat_${chatWidgetStatus === CWS.OPEN ? "opened" : "closed"}`, stateAfter, studentId, { num_unread_message: numUnreadMessages });

    const lastMesage = messageList?.[messageList?.length - 1];
    const eventName = lastMesage?.position === CHAT_SENDER_POSITION ? "message_sent" : "message_received";
    lastMesage && TE(eventName, stateAfter, studentId, { message_length: lastMesage.text?.length });
  },
  [setChatWidgetStatusAndUpdateReadTime.fulfilled]: (stateBefore, stateAfter, action) => {
    const numUnreadMessages = selectNumUnreadMessages(stateBefore);
    action?.payload !== CWS.SUSPENDED && TE(`chat_${action.payload === CWS.OPEN ? "opened" : "closed"}`, stateAfter, null, { num_unread_message: numUnreadMessages });
  },
  [sendChatMessage]: (stateBefore, stateAfter, action) => {
    const { newMessage } = action?.payload || {};
    const currUser = currentUser(stateAfter);
    currUser.role === ROLES.STUDENT.id && newMessage && TE("message_sent", stateAfter, null, { message_length: newMessage.text?.length });
  },
  [setMessageList]: (stateBefore, stateAfter, action) => {
    const messageList = action?.payload;
    const lastMesage = messageList?.[messageList?.length - 1];
    lastMesage?.position === CHAT_RECEIVER_POSITION && TE("message_received", stateAfter, null, { message_length: lastMesage.text?.length });
  },
  //tech stats
  [techStatusUpdateStudentStatus]: (stateBefore, stateAfter, action) => {
    const studentId = action?.payload?.id;
    const { payload: { changes = {} } = {} } = action || {};
    const { errorList: errorListChanges } = changes || {};
    
    if (errorListChanges) {
      const { errorList: prevErrorList } = (s => techStatusSelectStudentStatusById(s, studentId))(stateBefore) || { errorList: initErrorList }; //prev student tech errors
      const errorChanges = [];
      Object.entries(errorListChanges).forEach(err => {
        err[1]?.isActive !== prevErrorList[err[0]]?.isActive && errorChanges.push({ [err[0]]: err[1]?.isActive });
      });

      errorChanges?.length && TE("tech_error_change", stateAfter, studentId, { error_changes: errorChanges });
    }
  },
};
